import Nullstack from 'nullstack';
export default function IconTransitionTop({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-transition-top",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 6a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3"
  }), "   ", Nullstack.element("path", {
    d: "M6 21h12a3 3 0 0 0 0 -6h-12a3 3 0 0 0 0 6z"
  }), "   ", Nullstack.element("path", {
    d: "M12 15v-8"
  }), "   ", Nullstack.element("path", {
    d: "M9 10l3 -3l3 3"
  }), " ");
}